<script lang="ts">
  import type { ApiField } from '../../data-tables-api';
  import { toDateTimeLocalValue } from '../format';

  let {
    field,
    value,
    onChange,
    error,
    disabled = false,
  }: {
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  } = $props();

  const localValue = $derived(toDateTimeLocalValue(value));

  function handle(raw: string) {
    if (raw === '') {
      onChange(null);
      return;
    }
    // datetime-local format `2026-06-01T10:30` → передаємо як ISO без timezone.
    // Backend (Zod date) спарсить як локальний → UTC.
    onChange(new Date(raw).toISOString());
  }
</script>

<input
  type="datetime-local"
  value={localValue}
  oninput={(e) => handle((e.target as HTMLInputElement).value)}
  required={field.required}
  {disabled}
  class="w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[var(--color-pu)] {error ? 'border-red-400' : 'border-[var(--color-border-3)]'}"
/>
{#if error}
  <div class="mt-1 text-[11px] text-red-600">{error}</div>
{/if}
